import React, { useEffect, useState,useRef,useContext,useMemo,useCallback } from 'react';
import $ from 'jquery';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import DataTable from "react-data-table-component";
import { useNavigate } from 'react-router-dom';
import "react-quill-new/dist/quill.snow.css";
import RefreshContext from './RefreshContext';
import {
  Box, 
   Button, 
  Select as MuiSelect,
  MenuItem, 
  Typography, 
  Tooltip, 
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,
  ListItemIcon,Chip} from '@mui/material'; 
import { ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DownloadOutlined, DeleteOutline, EditOutlined, VisibilityOutlined, KeyboardArrowRight, FormatListBulleted, ArrowBackIosNew } from '@mui/icons-material';


function LineUp() {
const navigate = useNavigate(); const { refreshKey } = useContext(RefreshContext);
  const { aid ,aidtype} = useParams();
  const [staff, setStaff] = useState([]);const [newloading,setNewLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const searchRef = useRef(null);
  const [loading,setloading] = useState(null);
  const [requirement,setRequirement]= useState([]);
  const [order, setOrder] = useState('asc'); 
  const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
  const [globalFilterText, setGlobalFilterText] = useState('');
  const [columnFilters, setColumnFilters] = useState({});
  const [stats,setStats] = useState([]);

  const [metaData, setMetaData] = useState({
    typess: '',
    bd:false,check:false,manager:false
  });

const [currentPage, setCurrentPage] = useState(1);
const [totalRows, setTotalRows] = useState(0); // Set this from your API response
const limit = 50; 
const maxPage = Math.ceil(totalRows / limit);

  const fetchData = async (page) => {
    const response = await axios.get(apiurl + 'line.php?reid=react&page='+page+"&value="+aid); // Replace with your API endpoint
  
    setStaff(response.data.staff || []);
    setTotalRows(response.data.total_count || 1);
    setStats(response.data.stats || []);
   
    setMetaData({
      typess: response.data.typess,
      bd:response.data.bd,
      check:response.data.check,
      manager:response.data.manager
    });
    
  };

const dynamicFilterOptions = useMemo(() => {
    const options = {};
    const selectAccessors = ['location'];
    
    selectAccessors.forEach(key => {
        const uniqueValues = new Set();
        staff.forEach(row => {
            if (row[key]) {
                uniqueValues.add(row[key]);
            }
        });
        options[key] = Array.from(uniqueValues).sort();
    });
    return options;
}, [staff]);

    
const EditData = async (edit, sss) => {
    if (edit) {
    $("#showLoader").removeClass('d-none').addClass('d-flex');
    try {
        const response = await axios.get(apiurl + 'requirement.php?edit=' + edit);
        
        if (response.data.status == true) {
            setRequirement(response.data.data[0]);
            $("#table_modal").click();
    
        $("#showLoader").removeClass('d-flex').addClass('d-none');
        } else {
        // modal can't show
        $("#showLoader").removeClass('d-flex').addClass('d-none');
        alert("data not found");
        }

    }
    catch (error) {
        console.error('Error deleting category:', error);
    }

    }

};
  
const displayCount = 5;
let startPage = Math.max(1, currentPage - Math.floor(displayCount / 2));
let endPage = startPage + displayCount - 1;

if (endPage > maxPage) {
    endPage = maxPage;
    startPage = Math.max(1, endPage - displayCount + 1);
}

const pages = [];
for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
}

  useEffect(() => {
    document.title = "Line UP | MERAQUI";
    fetchData(currentPage);
    $('#modalclose').on('click', function () {
      $("#hidden").val("");
      $("#reset").click();
    });
  }, [aid,refreshKey,currentPage]);

  const RenderActionStatusCell = ({ rowData }) => {
    let classString = "btn btn-sm btn-success";
     return (
               <Button
                  variant="contained"
                  size="small"
                  color="info"
                  onClick={(e)=>{e.stopPropagation();navigate(`/admin/alllineup/${rowData.id}/112`)}}
                  className={classString} // Apply class here
              >
                  GET DETAILS
              </Button>
     );
  };
  
  const stableSort = (array, comparator) => {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
              return order;
          }
          return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
  };
  
  const getComparator = (order, orderBy) => {
      return order === 'desc'
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
  };
  
  const descendingComparator = (a, b, orderBy) => {
      const valA = orderBy(a);
      const valB = orderBy(b);
  
      if (valB < valA) {
          return -1;
      }
      if (valB > valA) {
          return 1;
      }
      return 0;
  };
  
  
 const ColumnHeaderWithFilter = ({ 
    column, 
    orderBySelector, 
    order, 
    handleRequestSort, 
    columnFilters, 
    setColumnFilters,
}) => {

    const [localOpenKey, setLocalOpenKey] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [tempFilter, setTempFilter] = useState("");

    const accessorKey = column.accessorKey;

    const isMenuOpen = localOpenKey === accessorKey;
    const currentFilter = String(columnFilters[accessorKey] || '');
    const isSorted = orderBySelector === column.selector;

    useEffect(() => {
        setTempFilter(currentFilter);
    }, [currentFilter]);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setLocalOpenKey(accessorKey);
        setTempFilter(currentFilter);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setLocalOpenKey(null);
    };

    const handleFilterChange = (e) => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: e.target.value
        }));
    };

    const handleTempChange = (e) => {
        setTempFilter(e.target.value);
    };

    const applySearch = () => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: tempFilter
        }));
        handleClose();
    };

    const isSortable = !!column.selector;
    const isFilterable = !!column.filterType;

    // --- Custom Filter Input Renderer ---
    const renderFilterInput = () => {

        if (column.filterType === 'select') {

            const filterOptions = column.dynamicFilterOptions || [];

            return (
                <MuiSelect
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    sx={{ width: '100%' }}
                >
                    <MenuItem value="">— All —</MenuItem>
                    {filterOptions.map(option => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                </MuiSelect>
            );
        }

        if (column.filterType === 'date') {
            return (
                <TextField
                    label={`Filter ${column.header}`}
                    type="date"
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: '100%' }}
                />
            );
        }

        // Default: text filter (with Search button)
        return (
            <>
                <TextField
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={tempFilter}
                    onChange={handleTempChange}
                    autoFocus
                    sx={{ width: '100%' }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            applySearch();
                        }
                    }}
                />

                <Button
                    variant="contained"
                    size="small"
                    onClick={applySearch}
                    sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                >
                    Search
                </Button>
            </>
        );
    };


    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                '& .MuiTableSortLabel-root': { flexGrow: 1 }
            }}
        >
            <TableSortLabel
                active={isSorted}
                direction={isSorted ? order : 'asc'}
                onClick={() => isSortable && handleRequestSort(column.selector)}
                IconComponent={isSorted ? (order === 'desc' ? ArrowDropDown : ArrowDropUp) : undefined}
                sx={{
                    cursor: isSortable ? 'pointer' : 'default',
                    justifyContent: column.headerAlign === 'center' ? 'center' : 'flex-start',
                    '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 'bold',
                    }
                }}
            >
                {column.header}
            </TableSortLabel>

            {isFilterable && (
                <>
                    <IconButton
                        aria-label="filter"
                        size="small"
                        onClick={handleClick}
                        sx={{
                            ml: 1,
                            p: 0,
                            color: currentFilter ? 'primary.main' : 'text.secondary',
                        }}
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>

                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleClose}
                        onClick={(e) => e.stopPropagation()}
                        PaperProps={{
                            sx: { width: 250, p: 1, boxShadow: 6, borderRadius: 2 }
                        }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >

                        <Box sx={{ width: '100%', p: 1 }}>
                            {renderFilterInput()}
                        </Box>

                        {currentFilter && (
                            <Button
                                onClick={() => {
                                    setColumnFilters(prev => ({
                                        ...prev,
                                        [accessorKey]: ''
                                    }));
                                    handleClose();
                                }}
                                size="small"
                                color="error"
                                sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                            >
                                Clear Filter
                            </Button>
                        )}

                    </Menu>
                </>
            )}
        </Box>
    );
};
  
  
const columns = useMemo(() => {
          let baseColumns = [
              { accessorKey: 'rid', header: 'Req. ID', size: 150, selector: (row) => row.requireds, filterType: 'text', headerAlign: 'center' },
              { accessorKey: 'lineup_id', header: 'Lineup ID', size: 120, selector: (row) => row.id, filterType: 'text' },
              { accessorKey: 'lineup_source', header: 'Source', size: 150, selector: (row) => row.lineup_source || row.campid, filterType: 'text' },
              { accessorKey: 'name', header: 'Client Name', size: 150, selector: (row) => row.client, filterType: 'text' },
              { accessorKey: 'title', header: 'Job Title', size: 150, selector: (row) => row.jobtitle, filterType: 'text' },
              { accessorKey: 'requested_by', header: 'Requested By', size: 150, selector: (row) => `${row.username || ''} ${row.userpost || ''}`.trim(), filterType: 'text' },
               { 
                  accessorKey: 'count', 
                  header: 'Line Up Count', 
                  size: 150, 
                  selector: (row) => row.count, 
                  filterType: 'text',
              },
              { 
                  accessorKey: 'Location', 
                  header: 'Location', 
                  size: 150, 
                  selector: (row) => row.location, 
                  filterType: 'select',
                  dynamicFilterOptions: dynamicFilterOptions['location']
              },
     { 
                  accessorKey: 'date', 
                  header: 'Line Up Time', 
                  size: 150, 
                  selector: (row) => row.dates, 
                  filterType: 'date' 
              },
              {
              accessorKey: 'bd_action',
              header: 'Action',
              selector: (row) => row.main,
              sortable: true,
              Cell: ({ row: { original } }) => (
                  <RenderActionStatusCell 
                      rowData={original} 
                  />
              ),
          }
  
          ];
         return baseColumns;
}, [dynamicFilterOptions]);
  
 const handleRequestSort = useCallback((selector) => {
          const isAsc = orderBySelector === selector && order === 'asc';
          setOrder(isAsc ? 'desc' : 'asc');
          setOrderBySelector(() => selector);
 }, [order, orderBySelector]);
  
 const processedData = useMemo(() => {
          let filtered = staff;
          const lowerCaseFilter = globalFilterText.toLowerCase();
  
          // 1. Apply Global Filter
          if (lowerCaseFilter) {
              filtered = filtered.filter(row => 
                  columns.some(column => {
                      const value = column.selector ? String(column.selector(row)) : '';
                      return value.toLowerCase().includes(lowerCaseFilter);
                  })
              );
          }
  
          // 2. Apply Column Filters
          filtered = filtered.filter(row => {
              return columns.every(column => {
                  const accessorKey = column.accessorKey;
                  const filterValue = columnFilters[accessorKey];
  
                  if (!filterValue) return true;
                  if (!column.selector) return true;
  
                  const rowValue = String(column.selector(row));
  
                  switch (column.filterType) {
                      case 'select':
                          // Must match the selected value exactly
                          return rowValue === filterValue; 
                          
                      case 'date':
                          // Check if the date string (e.g., '2024-01-15') includes the filter date
                          return rowValue.includes(filterValue); 
                          
                      case 'text':
                      default:
                          return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                  }
              });
          });
  
          // 3. Sorting Logic
          const sortColumn = columns.find(col => col.selector === orderBySelector);
  
          if (sortColumn) {
              return stableSort(filtered, getComparator(order, sortColumn.selector));
          }
          
          return filtered;
  
 }, [staff, columns, order, orderBySelector, globalFilterText, columnFilters]);
  
  
const RenderReqIdCell = useCallback(({ row }) => {
      const rowData = row;
       const isViewDetailClickable = true; // Set to true or use metaData.view check if needed
      
      let statsColor = '#10B981'; let idTooltipContent = 'Requirement In-process';
      if (rowData.rstatus.toLowerCase() === 'onhold') {
          statsColor = '#F59E0B'; idTooltipContent='Requirement Onhold';
      } else if (rowData.rstatus.toLowerCase() === 'closed') {
          statsColor = '#9CA3AF'; idTooltipContent='Requirement Closed';
      }
   return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' ,width:150}}>
  
             <Tooltip title={isViewDetailClickable ? 'View Detail' : ''} arrow>
                  <IconButton
                      size="small"
                      onClick={() => EditData(rowData.reqidhidden,"2")} 
                      sx={{
                          color: 'orange', 
                          p: 0.5,
                          '&:hover': {
                              color: isViewDetailClickable ? '#0056b3' : 'text.disabled',
                              backgroundColor: 'transparent'
                          }
                      }}
                  >
                      <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                  </IconButton>
              </Tooltip>
              
               <Tooltip title={idTooltipContent} arrow>
                  <Button
                      sx={{
                          background: "none",
                          border: "none",
                          color: statsColor, // Use status color for the ID text
                           padding: 0,
                          minWidth: 0, 
                          fontWeight: 500,
                          textAlign: 'left',
                          textTransform: 'none',
                          fontSize: '0.875rem',
                          '&:hover': { backgroundColor: 'transparent' }
                      }}
                  >
                      {rowData.requireds}
                  </Button>
              </Tooltip>
              
          </Box>
      );
}, [navigate, EditData]);

  return (
    <>
  
  <button data-bs-toggle="modal" id="tera_modal2"  data-bs-target="#allModal" type="button" style={{ display: 'none' }}></button>
  <button data-bs-toggle="offcanvas" id="tera_modal3" data-bs-target="#exampleModal" type="button" style={{ display: 'none' }}></button>
  <button data-bs-toggle="modal" id="table_modal" data-bs-target="#tableModal" type="button" style={{ display: 'none' }}></button>

      <div className="modal effect-super-scaled fade" id="tableModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-body" style={{maxHeight:'90vh',overflowX:'auto'}}>
<h5><strong>Requirement Detail</strong></h5>

<table className="table table-bordered" style={{ tableLayout: "fixed" }}>
  <tbody>
    {requirement && [
      ["RecID", "Branch", "CTC ", "", requirement.rid, requirement.branchh, requirement.ctcRange,""],
      ["Gender", "RecName", "Age", "Requirement Plan Dates", requirement.gender?.toUpperCase(), requirement.recname, requirement.ageRange, requirement.planDate],
      ["Client Name", "Anchor", "Location", "Experience", requirement.cidd, requirement.anchor, requirement.location, requirement.expRange],
      ["Education Type", "Commercials", "Designation", "Contact Name", requirement.education, requirement.commercials, requirement.posts, requirement.contactName],
      ["Contract", "Placement Type", "Job Title", "Requirement Status", requirement.contract, requirement.placementType, requirement.jobTitle, requirement.statuses],
      ["Cost Center", "Requirement Create Time", "No Of Position", "Pincode", requirement.costCenterbig, requirement.datestimes, requirement.noOfPosition, requirement.pincode],
    ].map((row, idx) => (
      <React.Fragment key={idx}>
        {/* Headings Row */}
        <tr>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[3]}</th>
        </tr>

        {/* Values Row */}
        <tr>
          <td>{row[4] || "-"}</td>
          <td>{row[5] || "-"}</td>
          <td>{row[6] || "-"}</td>
          <td>{row[7] || "-"}</td>
        </tr>
      </React.Fragment>
    ))}

    <tr>
       <th style={{ backgroundColor: "#e9ecef" }}>Keywords</th>
        <td colSpan="3">N/A</td>
    </tr>
  </tbody>
</table>


<h5 className="mt-4"><strong>Statistics Overview</strong></h5>
{/* New Statistics Overview Table */}
<table className="table table-bordered mt-4" style={{ tableLayout: 'fixed', width: '100%' }}>
  <tbody>
    {requirement && [
      ["Total Candidates", "Vendor Candidates", "Recruiter Candidates", requirement.tcandidate, requirement.vcandidate, requirement.rcandidate],
      ["Total Campaigns", "Campaign IVR Completed", "Campaign IVR Pending", requirement.tcampaign, requirement.isuccess, requirement.ipending],
      ["IVR Total Call ( Candidates )", "IVR Pending ( Candidates )", "IVR Completed ( Candidates )", requirement.ivrtotal, requirement.ivrpending, requirement.ivrcompleted],
      ["Lineups Candidates", "Selected Candidates", "Joined Candidates", requirement.lineup, requirement.selected, requirement.joined]
    ].map((row, idx) => (
      <>
        {/* Headings row */}
        <tr key={`st-head-${idx}`}>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
        </tr>

        {/* Values row */}
        <tr key={`st-val-${idx}`}>
          <td>{row[3]}</td>
          <td>{row[4]}</td>
          <td>{row[5]}</td>
        </tr>
      </>
    ))}
  </tbody>
</table>


        
            </div>
            <div className='modal-footer' style={{ padding: '0px' }}>
              <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" id="okayClose" aria-label="Close">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="main-content app-content">

        <div className="container-fluid">

          {/* Page Header */}
          <div className="mt-4 mb-3">
            <div style={{ display:'inline-flex', alignItems:'center', gap:'2px', background:'#f1f5f9', borderRadius:'10px', padding:'5px 10px', border:'1px solid #e2e8f0', marginBottom:'10px' }}>
              <span style={{ display:'inline-flex', alignItems:'center', gap:'5px', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:600, color:'#1e293b', background:'#ffffff', border:'1px solid #cbd5e1' }}>
                <FormatListBulleted sx={{ fontSize:'0.95rem', color:'#3b82f6' }} />
                Line Up
              </span>
            </div>
            <h4 className="fw-semibold mb-0" style={{ fontSize:'1.25rem', color:'#1e293b' }}>Line Up</h4>
          </div>

  <div className="row mt-3 mb-4 g-3">
    {[
      {
        title: 'Lineup Section',
        button: 'Candidate Line Up',
        route: `/admin/selflineup/${aid}/3`,
        accent: '#ef4444',
        background: 'linear-gradient(135deg, #fff5f5 0%, #ffe4e6 100%)',
        description: 'Candidates ready for line up',
      },
      {
        title: 'Selected Section',
        button: 'Selected Candidates',
        route: `/admin/selectedlineup/${aid}`,
        accent: '#f59e0b',
        background: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)',
        description: 'Candidates shortlisted after line up',
      },
    ].map((card) => (
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12" key={card.title}>
        <div className="card custom-card h-100" style={{ minHeight: '174px', background: card.background }}>
          <div className="card-body d-flex flex-column justify-content-between">
            <div className="d-flex justify-content-between align-items-start gap-3">
              <div>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <span
                    style={{
                      width: '4px',
                      height: '22px',
                      borderRadius: '8px',
                      backgroundColor: card.accent,
                      display: 'inline-block',
                    }}
                  />
                  <h6 className="fw-semibold mb-0">{card.title}</h6>
                </div>
                <p className="text-muted mb-0" style={{ fontSize: '0.82rem' }}>
                  {card.description}
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-end gap-3 mt-4">
              <button
                className="btn btn-primary text-nowrap"
                style={{ width: 'fit-content' }}
                onClick={() => navigate(card.route)}
              >
                {card.button}
              </button>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>

    {false && <div className="row">
            <div className="col-xxl-12 col-xl-12 ">
              <div className="card custom-card">
                <div className="card-header justify-content-between" style={{ paddingBottom: '15px', alignItems: 'normal' }}>
                  <div>
                    <h6 className="fs-16">Line Up List</h6>
                  </div>
                  <div className="d-flex mt-sm-0 mt-2 align-items-center gap-2">

                    <div className="input-group" >
                      <input type="search" className="form-control" placeholder="Search Campaign" id="search-member"  value={globalFilterText}
                    onChange={(e) => setGlobalFilterText(e.target.value)} />
                    </div>
                    <Tooltip title="Download Candidates Data" arrow>
                      <IconButton
                        size="medium"
                        onClick={() => {
                          window.location = `${apiurl}download.php?subdomain=react&export=xls&aid=${aid}&aidtype=${aidtype}`;
                        }}
                        sx={{
                          color: '#fff',
                          background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
                          borderRadius: '10px',
                          p: 1,
                          boxShadow: '0 4px 12px rgba(25, 118, 210, 0.35)',
                          transition: 'all 0.25s ease',
                          '&:hover': {
                            background: 'linear-gradient(135deg, #0d47a1, #1976d2)',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 6px 16px rgba(13, 71, 161, 0.45)',
                          },
                          '&:active': {
                            transform: 'scale(0.95)',
                          },
                        }}
                      >
                        <DownloadOutlined sx={{ fontSize: '1.4rem' }} />
                      </IconButton>
                    </Tooltip>
                  </div>

                </div>
                <div className="card-body" style={{ padding: '0px' }}>

           <TableContainer sx={{ maxHeight: '700px'}}>
                <Table stickyHeader aria-label="requirement tracker table">
                    
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.accessorKey}
                                    sx={{ 
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        p: 2.5,
                                        fontSize: '0.85rem', 
                                        verticalAlign: 'top',
                                    }}>
                                    <ColumnHeaderWithFilter
                                        column={column}
                                        orderBySelector={orderBySelector}
                                        order={order}
                                        handleRequestSort={handleRequestSort}
                                        columnFilters={columnFilters}
                                        setColumnFilters={setColumnFilters}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>


 <TableBody>
    {processedData.map((row, index) => (
        <TableRow key={index} >
            {columns.map((column) => {
                let cellContent;const cellWidth = column.size ? column.size : 150;
                  
                switch (column.accessorKey) {
                    case 'rid':
                        cellContent = <RenderReqIdCell row={row} />; 
                        break;
                    case 'requested_by':
                        cellContent = (
                            <div>
                                <div style={{ fontWeight: 500 }}>{row.username || '-'}</div>
                                <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                                    {row.userpost ? `(${row.userpost})` : '-'}
                                </div>
                            </div>
                        );
                        break;
                   
                   case 'bd_action':
                        cellContent = (
                            <RenderActionStatusCell 
                                rowData={row} 
                            />
                        );
                        break;
                        
                    default:
                        const value = column.selector ? column.selector(row) : null;
                        cellContent = value;
                        break;
                }

                return (
                    <TableCell 
                        key={column.accessorKey}
                        sx={{ p: 1.5, fontSize: '0.875rem',minWidth:cellWidth,width:cellWidth}}>
                        {cellContent}
                    </TableCell>
                );
            })}
        </TableRow>
    ))}
    
    {/* Empty state if no data */}
    {processedData.length === 0 && (
        <TableRow>
            <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                <Typography color="textSecondary" variant="body1">
                    No matching found in the current filters.
                </Typography>
            </TableCell>
        </TableRow>
    )}
</TableBody>
               
            </Table></TableContainer>
          
                </div>
                <div className="card-footer d-flex align-items-center justify-content-between" style={{ padding: '10px 25px' }}>
    <p className="text-muted mb-0">
        Showing <strong>{((currentPage - 1) * limit) + 1}</strong> – <strong>{Math.min(currentPage * limit, totalRows)}</strong> of <strong>{totalRows}</strong> entries
    </p>

    <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
            {/* First Page */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(1)}>« First</button>
            </li>

            {/* Previous */}
            <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>&laquo;</button>
            </li>

            {/* Dynamic Page Numbers */}
            {pages.map(pageNum => (
                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNum)}>
                        {pageNum}
                    </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${currentPage >= maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>&raquo;</button>
            </li>

            {/* Last Page */}
            <li className={`page-item ${currentPage === maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(maxPage)}>Last »</button>
            </li>
        </ul>
    </nav>
                </div>
              </div>
         </div>
    </div>}

        </div>
      </div>

    </>
  );
};
export default LineUp;
